import { createSelector } from 'reselect';

const foundReleaseList = createSelector(
  [
    (store) => store.search.data.releases.items,
    (store) => store.search.data.releases.total,
    (store) => store.artistList.data,
    (store) => store.releases.list.data,
  ],
  (foundIdList, total, artistList, releaseList) => ({
    items: foundIdList
      .map((id) => releaseList[id])
      .map((release) => ({
        ...release,
        artist: artistList[release.artist],
      })),
    total,
  }),
);

const foundTrackList = createSelector(
  [
    (store) => store.search.data.tracks.items,
    (store) => store.search.data.tracks.total,
    (store) => store.artistList.data,
    (store) => store.tracks.list,
  ],
  (foundIdList, total, artistList, trackList) => ({
    items: foundIdList
      .map((id) => trackList[id])
      .map((track) => ({
        ...track,
        artist: artistList[track.artist],
      })),
    total,
  }),
);

const foundArtistList = createSelector(
  [
    (store) => store.search.data.artists.items,
    (store) => store.search.data.artists.total,
    (store) => store.artistList.data,
  ],
  (foundIdList, total, artistList) => ({
    items: foundIdList.map((id) => artistList[id]),
    total,
  }),
);

const foundGenreList = createSelector(
  [
    (store) => store.search.data.genres.items,
    (store) => store.search.data.genres.total,
    (store) => store.genres.data,
  ],
  (foundIdList, total, genreList) => ({
    items: foundIdList.map((id) => genreList[id]),
    total,
  }),
);

const foundSeriesList = createSelector(
  [
    (store) => store.search.data.series.items,
    (store) => store.search.data.series.total,
    (store) => store.series.data,
  ],
  (foundIdList, total, seriesList) => ({
    items: foundIdList.map((id) => seriesList[id]),
    total,
  }),
);

const foundTotal = createSelector(
  [
    (store) => store.search.data,
  ],
  (results) => Object.keys(results).reduce((acc, type) => acc + results[type].total, 0),
);

export {
  foundReleaseList,
  foundTrackList,
  foundTotal,
  foundArtistList,
  foundGenreList,
  foundSeriesList,
};
